import { Controller } from '@hotwired/stimulus';
// Inspiration: https://newgenre.studio/services#approach
// Comportement Desktop : l'image s'affiche au hover et se positionne en suivant le curseur
export default class extends Controller {
    static targets = [
        'item' // chaque lien de la liste
    ];

    connect() {
        // Binding Desktop
        this.onHover = this.hover.bind(this);
        this.onOut = this.out.bind(this);
        this.onResizeModeChange = this.onResizeModeChange.bind(this);

        // Mémorise le dernier mode connu (desktop / mobile)
        this.wasDesktopOnLastUpdate = null;

        // Initialisation selon l'écran
        this.updateMode();

        // Gestion du resize pour passer d'un état à l'autre
        window.addEventListener('resize', this.onResizeModeChange);
    }

    disconnect() {
        // Suppression des binding
        this.disableDesktopMode();
        window.removeEventListener('resize', this.onResizeModeChange);
    }

    // Desktop : l'image s'affiche au hover et se positionne en suivant le curseur
    hover(event) {
        if (event.pointerType && event.pointerType !== 'mouse') {
            event.currentTarget.style.cursor = 'none';
        }

        // Item courant
        const item = event.currentTarget;

        // On récupère l'image associée à cet item via l'attribut data-image
        const itemImage = item.querySelector('[data-image]');

        if (!itemImage) {
            return;
        }

        // On affiche l'image et on la positionne en fonction du curseur
        itemImage.setAttribute('data-show', 'true');
        // Ajout d'un délai pour créer un effet "smoooth"
        itemImage.style.left = `${event.clientX}px`;
        itemImage.style.top = `${event.clientY}px`;
    }

    out(event) {
        if (event.pointerType !== 'mouse') {
            event.currentTarget.style.cursor = null;
        }

        const item = event.currentTarget;
        const itemImage = item.querySelector('[data-image]');

        if (!itemImage) {
            return;
        }

        // On masque l'image de survol de cet item uniquement
        itemImage.removeAttribute('data-show');
        itemImage.style.left = 'auto';
        itemImage.style.top = 'auto';

    }

    // Changement de mode desktop / mobile en fonction du viewport
    updateMode() {
        const isCurrentlyDesktop = !window.matchMedia('(max-width:999px)').matches;

        // Si on ne change pas de device on ne fait rien
        if (this.wasDesktopOnLastUpdate === isCurrentlyDesktop) {
            return;
        }

        // On chaneg de mode, on met à jour les event listener
        if (isCurrentlyDesktop) {
            this.enableDesktopMode();
        } else {
            this.disableDesktopMode();
        }

        this.wasDesktopOnLastUpdate = isCurrentlyDesktop;
    }

    onResizeModeChange() {
        this.updateMode();
    }

    // Activation / désactivation du mode desktop
    enableDesktopMode() {
        // On écoute chaque item individuellement pour gérer son propre hover-image
        this.itemTargets.forEach((item) => {
            item.addEventListener('mousemove', this.onHover);
            item.addEventListener('mouseout', this.onOut);
        });
    }

    disableDesktopMode() {
        this.itemTargets.forEach((item) => {
            item.removeEventListener('mousemove', this.onHover);
            item.removeEventListener('mouseout', this.onOut);
            const itemImage = item.querySelector('[data-image]');
            itemImage.style.left = 'auto';
            itemImage.style.top = 'auto';
        });
    }
}